export default class PersistenceError extends Error {
	constructor(code = "", message) {
		super(message)
		this.code = code;
	}
}